export const ValidationRules = {
    companyName: [
      { required: true, message: "Şirket adı zorunludur" },
      { min: 2, message: "Şirket adı en az 2 karakter olmalıdır" },
      { max: 100, message: "Şirket adı en fazla 100 karakter olabilir" }
    ],
    email: [
      { required: true, message: "E-posta adresi zorunludur" },
      { 
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: 'E-posta formatı geçersiz'
      }
    ],
    phone: [
      { required: true, message: "Telefon numarası zorunludur" },
      { 
        pattern: /^[5][0-9]{9}$/,
        message: 'Geçerli bir Türkiye telefon numarası giriniz (5XX XXX XX XX)'
      }
    ],
    taxNumber: [
      { required: true, message: "Vergi numarası zorunludur" },
      { 
        pattern: /^[0-9]{10}$/,
        message: 'Vergi numarası 10 haneli olmalıdır'
      }
    ],
    password: [
      { required: true, message: "Şifre zorunludur" },
      { min: 6, message: "Şifre en az 6 karakter olmalıdır" },
    ],
    name: [
      { required: true, message: "Bu alan zorunludur" },
      { min: 2, message: "En az 2 karakter olmalıdır" },
      { max: 50, message: "En fazla 50 karakter olabilir" },
      {
        pattern: /^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]+$/,
        message: 'Sadece harf ve boşluk karakteri kullanabilirsiniz'
      }
    ]
  };
  